<template>
    <div>
        <div class="card bg-light mb-0">
            <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <h6 class="mb-0"><font-awesome-icon icon="plus-circle" /> Job Title</h6>
            </div>
            <div class="card-body bg-white position-relative">
                <b-row align-v="center" class="loader" v-if="is_saving">
                    <b-col>
                        <b-spinner></b-spinner>
                        <br><br>
                        <strong>Loading</strong>
                    </b-col>
                </b-row>
                <b-form @submit.prevent="save">

                    <b-form-group
                            label="Job Title:"
                            description="This field is required"
                    >
                        <select class="form-control form-control-sm"  required @change="selectJob($event)">
                            <option value="">Please Select</option>
                            <option v-for="row in job_descriptions" :value="row.id">
                                {{row.description}}
                            </option>
                        </select>
                    </b-form-group>
                    <b-form-group
                            label="Monthly Rate:"
                            description="This field is required"
                    >
                        <b-form-input
                                v-model="form.monthly_rate"
                                type="number"
                                step="any"
                                required
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                            label="Daily Rate:"
                            description="This field is required"
                    >

                        <b-input-group>
                            <b-form-input
                                    v-model="form.daily_rate"
                                    type="number"
                                    step="any"
                                    required
                            ></b-form-input>

                            <template #append>
                                <b-input-group-text class="bg-info text-white">Projected Daily Rate:<strong class="ml-1">P {{daily_rate}}</strong></b-input-group-text>
                            </template>
                        </b-input-group>

                    </b-form-group>
                    <b-form-group
                            label="Job Description:"
                            description="This field is required"
                    >

                        <b-form-textarea
                                id="textarea"
                                v-model="form.job_description"
                                placeholder="..."
                                rows="3"
                                max-rows="6"
                                readonly
                        ></b-form-textarea>
                    </b-form-group>
                    <b-form-group label="Effective Date:" description="This field is required">
                        <b-form-input v-model="form.effective_date" type="date" required size="sm"></b-form-input>
                    </b-form-group>
                    <b-form-group
                            label="Remarks:"
                            description="This field is required"
                    >

                        <b-form-textarea
                                id="textarea"
                                v-model="form.remarks"
                                placeholder="..."
                                rows="3"
                                max-rows="6"
                                required
                        ></b-form-textarea>
                    </b-form-group>
                    <div class="text-right mt-3">
                        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Save</b-button>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    import SwalMixin from '@/views/mixins/Swal.js'
    export default {
        mixins:[SwalMixin],
        data() {
            return {
                is_saving:false,
                form:{
                    id:-1,
                    job_description_id:'',
                    effective_date:'',
                    job_description:'',
                    monthly_rate:'',
                    daily_rate:''
                },
                job_descriptions:[]
            }
        },

        created(){
            this.getFields();
        },
        computed: {
            daily_rate(){
                let daily = Number(this.form.monthly_rate/26).toFixed(2);
                return Number(daily).toLocaleString('en-US');
            },
        },
        methods: {

            getFields(){
                this.is_saving=true;
                this.axios.get('maintenance/job_descriptions/all').then(response => {
                    this.job_descriptions=response.data;
                    this.is_saving=false;
                }).catch(error => console.log(error));
            },
            selectJob(event){
                let selected_job = this.job_descriptions.find(element => element.id==event.target.value);
                this.form.job_description_id = event.target.value;
                this.form.monthly_rate=selected_job.monthly_rate.default;
                this.form.daily_rate=selected_job.daily_rate.default;
                this.form.job_description=selected_job.full_description;
            },
            save() {
                this.swalConfirmSubmit((data) => {
                    if (data.value) {
                        this.is_saving = true;
                        this.form.manpower_id = this.$route.params.id;
                        this.axios.post('maintenance/manpowers/job-descriptions/save', this.form).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving = false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving = false;
                        });
                    }
                });
            },
        }
    }
</script>
